import {
  AppMultiSelect,
  AppRemixIcon,
  AppSingleSelect,
} from '@/layout/AppComponents';
import errorHandler from '@/layout/components/error/ErrorHandler';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useDispatch } from 'react-redux';
import { axiosPath } from '../../../../routing/helpers/router';
import Translator from '../../helpers/Translator';

export default function ClassifiedPlantSelect(props) {
  const {
    value,
    title,
    placeholder,
    onChange,
    error,
    isDisabled,
    className = 'mb-2',
    isMulti = false,
    isClearable = false,
    hasSelectOptions = true,
    onlyIcpe = false,
    plantHex = null,
    addNoClassifiedPlantsOption = undefined,
  } = props;
  const dispatch = useDispatch();
  const [options, setOptions] = useState();

  const loadOptions = useCallback(
    async () =>
      axios
        .post(axiosPath('api_r_user_global_select_classifiedPlants'), {
          onlyIcpe,
          plantHex,
          addNoClassifiedPlantsOption,
        })
        .then((r) => {
          setOptions(r.data);
        })
        .catch((e) => dispatch(errorHandler(e))),

    [onlyIcpe, plantHex, addNoClassifiedPlantsOption],
  );
  useEffect(() => {
    if (!options) loadOptions();
  }, []);

  if (isMulti) {
    return (
      <AppMultiSelect
        icon={<AppRemixIcon icon="apps-2" />}
        options={options}
        title={
          title ||
          ReactDOMServer.renderToString(
            <Translator
              file="module-legalCompliance"
              name="module.lc.classified-installations"
            />
          )
        }
        placeholder={
          placeholder ||
          ReactDOMServer.renderToString(
            <Translator
              file="module-legalCompliance"
              name="module.lc.select-one-more-classified-installations"
            />
          )
        }
        value={value}
        onChange={(opt) => onChange(opt)}
        allowSelectAll
        isLoading={!options}
        hasSearchBox
        hasSelectOptions={hasSelectOptions}
        error={error}
        isDisabled={isDisabled}
        isClearable={isClearable}
        className={className}
      />
    );
  }

  return (
    <AppSingleSelect
      icon={<AppRemixIcon icon="apps-2" />}
      options={options}
      title={
        title ||
        ReactDOMServer.renderToString(
          <Translator file="admin" name="client.classified-installation" />
        )
      }
      placeholder={
        placeholder ||
        ReactDOMServer.renderToString(
          <Translator
            file="admin"
            name="client.select-classified-installation"
          />
        )
      }
      value={value}
      onChange={(opt) => onChange(opt)}
      allowSelectAll
      isLoading={!options}
      hasSearchBox
      hasSelectOptions
      error={error}
      isClearable={isClearable}
      isDisabled={isDisabled}
      className={className}
    />
  );
}
